"use strict";
export function feature_js_recipe_modal(el) {
    el.click(function () {
        if ($('[js-content]').attr('js-is-locked')) $('#recipelabel-warning-modal').modal('show');
        else {
            $('#recipelabel-delete-modal').modal('show');
            window.recipe_information_remove = el;
            }
    });
}